/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SubmissionDto
 */
export interface SubmissionDto {
    /**
     * Submission ID
     * @type {string}
     * @memberof SubmissionDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof SubmissionDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof SubmissionDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof SubmissionDto
     */
    'deletedAt': string;
    /**
     * Activity ID
     * @type {string}
     * @memberof SubmissionDto
     */
    'activityId': string;
    /**
     * Challenge category participation ID
     * @type {string}
     * @memberof SubmissionDto
     */
    'participationId': string;
    /**
     * Submission approval status
     * @type {string}
     * @memberof SubmissionDto
     */
    'status': SubmissionDtoStatusEnum;
    /**
     * Reason for decline (only when status is declined)
     * @type {string}
     * @memberof SubmissionDto
     */
    'declineReason'?: string;
    /**
     * Challenge ID for easy reference
     * @type {string}
     * @memberof SubmissionDto
     */
    'challengeId'?: string;
    /**
     * Challenge name for easy reference
     * @type {string}
     * @memberof SubmissionDto
     */
    'challengeName'?: string;
    /**
     * Distance of the participation category in meters
     * @type {number}
     * @memberof SubmissionDto
     */
    'categoryDistance'?: number;
    /**
     * Distance added by this submission in meters (0 for pending/declined, activity distance for approved)
     * @type {number}
     * @memberof SubmissionDto
     */
    'distanceAdded'?: number;
    /**
     * Running distance covered at the time of submission in meters
     * @type {number}
     * @memberof SubmissionDto
     */
    'runningDistanceCovered'?: number;
}

export const SubmissionDtoStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;

export type SubmissionDtoStatusEnum = typeof SubmissionDtoStatusEnum[keyof typeof SubmissionDtoStatusEnum];


